import { Component } from '@angular/core';

@Component({
  selector: 'app-investment-systems',
  templateUrl: './investment-systems.component.html',
  styleUrl: './investment-systems.component.scss'
})
export class InvestmentSystemsComponent {

}
